import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { 
    action_cart_add_to_wish, 
    action_cart_select, 
    action_cart_remove_items,
    action_cart_change_qty,
    action_cart_change_item,
    action_cart_set_country,
    action_cart_set_coupon,
    action_cart_use_coupon_code,
} from '../../../../../../store/actions/pages/cart'


import { 
    setCountry
} from '../../../../../../store/actions/global'

import _ from 'lodash'

export default () => {
    const dispatch = useDispatch()

    const removeItemsHandle = useCallback(itemIds => {
        return dispatch(action_cart_remove_items(itemIds))
    }, [])

    const addToWishList = useCallback((itemIds, productIds) => {
        return dispatch(action_cart_add_to_wish(itemIds, productIds))
    }, [])

    const itemSelectHandle = useCallback(item => {
        return dispatch(action_cart_select(item.id, !item.selected))
    }, [])

    const itemChangeQtyHandle = useCallback((item, qty) => {
        return dispatch(action_cart_change_qty({
            itemId: item.id,
            qty,
            variantId: item.variantId
        }))
    })

    const itemChangeItemHandle = useCallback((item, data) => {
        return dispatch(action_cart_change_item({
            itemId: item.id,
            qty: data?.quantity,
            variantId: data.variantId
        }))
    })

    

    const groupSelectHandle = useCallback((regionalCase, select) => {
        const { caseItems } = regionalCase
        const itemIds = _.reduce(caseItems, (result, caseItem, index) => {
            const { shoppingCartProducts } = caseItem || {}
            return [...result, ...shoppingCartProducts]
        }, [])?.map(item => item.id)?.join(',')

       return dispatch(action_cart_select(itemIds, select))
    }, [])

    const setCountryHandle = useCallback(({ country, state, city }) => {
        dispatch(setCountry(country))
        return dispatch(action_cart_set_country(country))
    }, [])

    const setCouponHandle = useCallback(couponId => {
        return dispatch(action_cart_set_coupon(couponId))
    }, [])

    const applyCouponCodeHandle = useCallback(async code => {
        return dispatch(action_cart_use_coupon_code(code))
    }, [])


    return {
        addToWishList,
        itemSelectHandle,
        groupSelectHandle,
        removeItemsHandle,
        itemChangeQtyHandle,
        itemChangeItemHandle,
        setCountryHandle,
        setCouponHandle,
        applyCouponCodeHandle,
    }
}